<template>
    <div>
        <preview-pdf
            :preview-url="finalSelectionUrl"
            :download-url="finalSelectionDownloadUrl"
            :open-label="trans('audit_tool.project_workflow.submit_invoices.final_selection_form_preview_button')"
            class="mb-4"
            :disabled="isSubmitted || !canPreviewAndGenerate"
        ></preview-pdf>
        <adobe-sign-request
            v-if="canPreviewAndGenerate && useAdobeSign && !isSubmitted"
            model-type="project"
            :model-id="project.id"
            agreement-type="final-selection-form"
            :additional-args="{phase: reportPhase.id, scenario: reportScenarioId}"
            :generate-text="trans('audit_tool.project_workflow.submit_invoices.final_selection_form_generate_button')"
            :regenerate-text="trans('audit_tool.project_workflow.submit_invoices.final_selection_form_re_generate_button')"
            :sign-text="trans('audit_tool.project_workflow.submit_invoices.final_selection_form_sign_button')"
        ></adobe-sign-request>
        <div v-if="!canPreviewAndGenerate">
            <span v-html="trans('audit_tool.project_workflow.report_validation_messages.final_selection_form')"></span>
        </div>
    </div>
</template>
<script>
    import ValidateFinalSelectionFormGeneration from './../../mixins/validate_final_selection_form_generation.js';

    export default {
        mixins: [
            ValidateFinalSelectionFormGeneration
        ],

        props: {
            reportPhase: {
                type: Object,
            },
            reportScenarioId: {
                type: Number,
            },
            project: {
                required: true,
            },
            useAdobeSign: {
                type: Boolean,
                default: false,
            },
            currentScenario: {
                required: true,
                type: Object
            },
            isSubmitted: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                canPreviewAndGenerate: false,
            }
        },

        created() {
            this.validateFinalSelectionFormGeneration().then(success => {
                this.canPreviewAndGenerate = true;
            }).catch( error => {
                if(error !== 'apiError') {
                    this.canPreviewAndGenerate = false;
                }
            });
        },

        computed: {
            finalSelectionUrl() {
                return '/project/' + this.project.id + '/generate_final_selection?action=view&type=final_selection_form';
            },
            finalSelectionDownloadUrl() {
                return '/project/' + this.project.id + '/generate_final_selection?action=download&type=final_selection_form';
            },
            projectMeasures() {
                return this.$store.state.mp_project_measures.projectMeasures;
            }
        },

        watch: {
            projectMeasures: {
                handler(projectMeasures) {
                    if(Array.isArray(projectMeasures) && projectMeasures.length > 0) {
                        this.validateFinalSelectionFormGeneration().then(success => {
                            this.canPreviewAndGenerate = true;
                        }).catch( error => {
                            if(error !== 'apiError') {
                                this.canPreviewAndGenerate = false;
                            }
                        });
                    } else {
                        this.canPreviewAndGenerate = false;
                    }
                },
                deep: true,
            }
        },
    }
</script>
